import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc, collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

function HomePage({ user, setShowLogin }) {
  const [recentPosts, setRecentPosts] = useState([]);
  const [usernames, setUsernames] = useState({});

  useEffect(() => {
    const q = query(collection(db, 'posts'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let postDocs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // Only show the most recent 3 posts for unauthenticated users
      if (!user) {
        postDocs = postDocs.slice(0, 3);
      }
      setRecentPosts(postDocs);
      const uniqueUserIds = Array.from(new Set(postDocs.map(post => post.userId)));
      uniqueUserIds.forEach(async (uid) => {
        if (!usernames[uid]) {
          const userRef = doc(db, 'users', uid);
          const snap = await getDoc(userRef);
          setUsernames(prev => ({ ...prev, [uid]: snap.exists() && snap.data().username ? snap.data().username : '' }));
        }
      });
    });
    return () => unsubscribe();
  }, [user, usernames]);

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px' }}>
      {/* Title */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '40px' }}>
        <img src="/logo.png" alt="Logo" style={{ height: '50px', width: '50px' }} />
        <h1 style={{
          textAlign: 'center',
          fontSize: '3em',
          color: '#133250',
          margin: 0,
          fontWeight: 'bold',
          letterSpacing: '1px'
        }}>
          Interview[insider]
        </h1>
      </div>

      {/* Buttons Section */}
      <div style={{
        display: 'flex',
        gap: '16px',
        justifyContent: 'center',
        marginBottom: '48px',
        flexWrap: 'wrap'
      }}>
        {user ? (
          // Authenticated User Buttons
          <>
            <Link
              to="/post"
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#80B5D7',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '6px',
                fontSize: '1em',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
                transition: '0.3s',
                boxShadow: '0 2px 8px rgba(128, 181, 215, 0.3)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#5895b8';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(128, 181, 215, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#80B5D7';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(128, 181, 215, 0.3)';
              }}
            >
              [post your experience!]
            </Link>
            <Link
              to="/search"
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#80B5D7',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '6px',
                fontSize: '1em',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
                transition: '0.3s',
                boxShadow: '0 2px 8px rgba(128, 181, 215, 0.3)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#5895b8';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(128, 181, 215, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#80B5D7';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(128, 181, 215, 0.3)';
              }}
            >
              [search posts!]
            </Link>
          </>
        ) : (
          // Unauthenticated User Buttons
          <>
            <Link
              to="/search"
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#80B5D7',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '6px',
                fontSize: '1em',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
                transition: '0.3s',
                boxShadow: '0 2px 8px rgba(128, 181, 215, 0.3)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#5895b8';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(128, 181, 215, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#80B5D7';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(128, 181, 215, 0.3)';
              }}
            >
              [search posts!]
            </Link>
            <button
              onClick={() => setShowLogin(true)}
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#BCC7D9',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '6px',
                fontSize: '1em',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
                transition: '0.3s',
                boxShadow: '0 2px 8px rgba(188, 199, 217, 0.3)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#80B5D7';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(128, 181, 215, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#BCC7D9';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(188, 199, 217, 0.3)';
              }}
            >
              [log in or sign up!]
            </button>
          </>
        )}
      </div>

      {/* Recent Posts Section */}
      {!user && (
        <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', padding: '24px', marginTop: '32px' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>Recent Posts</h2>
          {recentPosts.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#888' }}>No posts yet.</p>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {recentPosts.map((post) => (
                <li key={post.id} style={{ border: '1px solid #e0e0e0', borderRadius: '8px', margin: '16px 0', padding: '16px', background: '#fafafa', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                  <Link
                    to={user ? `/post/${post.id}` : '#'}
                    state={{ from: '/' }}
                    onClick={(e) => !user && e.preventDefault()}
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      cursor: user ? 'pointer' : 'default',
                      display: 'block',
                      transition: 'background-color 0.2s',
                    }}
                    onMouseOver={(e) => {
                      if (user) {
                        e.currentTarget.style.backgroundColor = '#f0f0f0';
                      }
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <strong style={{ fontSize: '1.1em', color: '#222' }}>{post.companyName}</strong> - <span style={{ color: '#555' }}>{post.roleName}</span><br />
                    <span style={{ color: '#666' }}>Rounds: {post.numRounds} | Rating: {post.rating}</span><br />
                    <span style={{ color: '#444' }}>Offer: {post.offerReceived ? 'Yes' : 'No'}</span><br />
                    <span style={{ color: '#888', fontSize: '0.9em' }}>By: {usernames[post.userId]}</span>
                  </Link>
                  {/* Prompt for unauthenticated users */}
                  {!user && (
                    <div style={{marginTop: '8px', color: '#b00', fontWeight: 500, fontStyle: 'italic', fontSize: '1em'}}>
                      Please <span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={() => setShowLogin && setShowLogin(true)}>sign in</span> to see more details about this post.
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default HomePage;